import { createMoment, getDate } from './DateFormatter';

export const startOfMonth = () => createMoment().startOf('month').format('YYYY-MM-DD');

export const currentToNextMonth = () => {
  const From = createMoment().format('YYYY-MM-DD');
  const To = createMoment().add(1, 'M').format('YYYY-MM-DD');
  return { From, To };
};

export const lastMonth = () => {
  const From = createMoment().add(-1, 'M').startOf('month').format('YYYY-MM-DD');
  const To = createMoment().add(-1, 'M').endOf('month').format('YYYY-MM-DD');

  return { From, To };
};
export const currentToLastYear = () => {
  const From = createMoment().subtract(1, 'years').add(1, 'days').format('YYYY-MM-DD');
  const To = createMoment().format('YYYY-MM-DD');
  return { From, To };
};

export const currentTo3yearAgo = () => {
  const curYear = createMoment().year();
  const From = createMoment()
    .startOf('month')
    .year(curYear - 3)
    .format('YYYY-MM-DD');
  const To = createMoment().format('YYYY-MM-DD');
  return { From, To };
};

export const nearestMonday = () => createMoment().startOf('isoWeek').subtract(1, 'week').format('YYYY-MM-DD');

export const getCurrentYearList = () => {
  const currentYear = getDate().year();
  return new Array(10).fill(undefined).map((_, index) => {
    const cur = currentYear - index;
    const temp = {
      label: String(cur),
      value: String(cur),
    };
    if (index === 0) {
      Object.assign(temp, { isDefault: true });
    }

    return temp;
  });
};
